import React, { useEffect, useState } from "react";
import Modal from "../ui/Modal";
import InputText from "../ui/InputText";
import SelectInput from "../ui/SelectInput";
import { useSelector } from "react-redux";
import {
  FaCheck,
  FaCheckCircle,
  FaMinus,
  FaRegAddressCard,
  FaRegBuilding,
  FaSearch,
  FaUser,
  FaUserCircle,
} from "react-icons/fa";
import axios from "axios";
import Datepicker from "react-tailwindcss-datepicker";
import { BACKEND } from "../../config/configEnvs";
import { toast } from "react-toastify";
import { TbWand } from "react-icons/tb";
import FormLoader from "../ui/FormLoader";
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

const NuevaCotizacionDialog = ({ open, onClose, title, onSuccess }) => {

  const [formValues, setFormValues] = useState({
    //nombreLead: "",
    //leadDNI: "",
    //leadRUC: "",
    //leadCompany: "",
    //fuenteLead: "",
    numeroCotizacion: "",
    //moneda: "",
    fechaCotizacionLimite: {
      startDate: null,
      endDate: null,
    },
    clienteFrecuente: false,
    country: true
  });

  const handleChange = (event, newAlignment) => {
    if (newAlignment !== null) {
      setFormValues((prev) => ({
        ...prev,
        clienteFrecuente: newAlignment, // Aquí se actualiza correctamente
      }));
    }
  };
  
  // const [validRUC, setValidRUC] = useState(false);
  // const [validDNI, setValidDNI] = useState(false);

  // const [isFormLoading, setIsFormLoading] = useState(false);
  // const [isDniLoading, setIsDniLoading] = useState(false);
  // const [isRucLoading, setIsRucLoading] = useState(false);

  const userRedux = useSelector((state) => state.auth);

  const registerCotizacion = async (event) => {
    event.preventDefault();

    if (formValues.clienteFrecuente && !selectedCliente) {
      toast.warning("Selecciona un cliente");
      return;
    }

    if (!formValues.clienteFrecuente && !selectedLead) {
      toast.warning("Selecciona un lead");
      return;
    }

    // if (formValues.moneda === "") {
    //   toast.warning("Selecciona una moneda");
    //   return;
    // }

    if (!formValues.fechaCotizacionLimite.startDate) {
      toast.warning("Selecciona una fecha limite");
      return;
    }

    // if (formValues.fuenteLead === "") {
    //   toast.warning("Selecciona una fuente Lead");
    //   return;
    // }

    // if(!formValues.clienteFrecuente){
    //   if (formValues.country && !validDNI) {
    //     toast.warning("Valida el DNI del cliente");
    //     return;
    //   }
    //   if (formValues.country && !validRUC) {
    //     toast.warning("Valida el RUC del cliente");
    //     return;
    //   }
    // }

    try {
      await axios.post(`${BACKEND}/api/cotizaciones`, {
        cliente: selectedCliente ? selectedCliente.id : null,
        // leadNombre: selectedLead.nombreLead,
        // leadDNI: selectedLead.leadDNI,
        // leadRUC: selectedLead.leadRUC,
        // leadCompany: selectedLead.leadCompany,
        lead: selectedLead ? selectedLead.id : null,
        cotizador: userRedux.user.id,
        // fuenteLead: selectedLead.leadOrigin ? selectedLead.leadOrigin : "Orgánico",
        // numeroCotizacion: formValues.numeroCotizacion,
        fechaCotizacionLimite: formValues.fechaCotizacionLimite.startDate,
        tipo: "Cotizacion",
        estado: "En espera",
        // moneda: formValues.moneda,
        precioTotal: 0,
        fuenteVentas: formValues.clienteFrecuente ? "Agencia" : "Comercial",
        tipoDescuento: "fijo",
      });

      setFormValues({
        nombreLead: "",
        leadDNI: "",
        leadRUC: "",
        leadCompany: "",
        fuenteLead: "",
        numeroCotizacion: "",
        //moneda: "",
        fechaCotizacionLimite: {
          startDate: null,
          endDate: null,
        },
        clienteFrecuente: false,
      });

      // setValidDNI(false);
      // setValidRUC(false);
      setSelectedCliente(null)
      setSelectedLead(null)
      onClose();
      toast.success("Registrado exitosamente");
      onSuccess();
    } catch (e) {
      toast.error("Error al crear la cotización: " + e)
    }
  };

  const [searchInputClientes, setSearchInputClientes] = useState("");
  const [allClientesUserList, setAllClientesUserList] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState(null);

  const [searchInputLeads, setSearchInputLeads] = useState("")
  const [allLeadsUserList, setAllLeadsUserList] = useState([])
  const [selectedLead, setSelectedLead] = useState(null)

  const getInitialClientesWithQuery = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/clientesUser?where[nombreComercial][like]=${searchInputClientes}`)
      setAllClientesUserList(response.data.docs)

    } catch (e) {
      toast.error("Error al obtener los cliente: " + e)
    }
  };

  const getSubmitClientes = async (event) => {
    event.preventDefault();
    await getInitialClientesWithQuery();
  };

  const getInitialLeadsWithQuery = async () => {
    try {
      let url = `${BACKEND}/api/registroLeads?limit=10&page=1`

      if (searchInputLeads) {
        url += `&where[id][equals]=${searchInputLeads}`
      }

      const response = await axios.get(url)

      setAllLeadsUserList(response.data.docs)
      
    } catch (e) {
      toast.error("Error al obtener los leads: " + e)
    }
  }
  
  const getSubmitLeads = async (event) => {
    event.preventDefault();
    await getInitialLeadsWithQuery();
  };
  
  useEffect(() => {
    getInitialClientesWithQuery();
    getInitialLeadsWithQuery()
  }, []);

  return (
    <Modal 
      activeModal={open} 
      onClose={() => {
        onClose()
        setSelectedCliente(null)
        setSelectedLead(null)
      }} 
      title={title} 
      centered
    >
      <form onSubmit={registerCotizacion}>

        {/* Cotizador */}
        <div className=" mb-3 flex flex-row gap-4 md:grid md:grid-cols-2">
          <div className=" inline-flex items-center p-2 text-green-500 rounded-md bg-green-50">
            <div className=" p-2 ">
              <FaUser className=" w-4 h-4" />
            </div>
            <div className=" flex flex-col ">
              <span className=" text-base font-bold text-xs ">
                {" "}
                {userRedux && userRedux?.user.name}
              </span>
              <span className=" text-xs ">Cotizador</span>
            </div>
          </div>
          <div>
            <label
              htmlFor={"fechaCotizacionLimite"}
              class="block mb-2 text-xs font-medium text-gray-900"
            >
              Fecha cotización límite
            </label>
            <Datepicker
              popoverDirection={"down"}
              toggleClassName="absolute text-xs bg-blue-300 rounded-r-lg text-white right-0 h-full px-3 text-gray-400 focus:outline-none disabled:opacity-40 disabled:cursor-not-allowed"
              inputClassName={"rounded-md text-xs bg-gray-50 border border-gray-300 py-2 px-10 text-gray-700"}
              inputId="fechaCotizacionLimite"
              containerClassName={"relative"}
              useRange={false}
              asSingle={true}
              classNames={" z-[9999]"}
              placeholder={"Fecha límite"}
              value={formValues.fechaCotizacionLimite}
              onChange={(e) => {
                if (new Date(e.startDate) > new Date()) {
                  setFormValues((prev) => ({
                    ...prev,
                    fechaCotizacionLimite: e,
                  }));
                  console.log(e);
                } else {
                  toast.warning("La fecha limite es menor a la fecha de hoy", {
                    style: { zIndex: 9999 },
                    position: "top-center",
                  });
                }
              }}
            />
          </div>
        </div>
        
        {/* Fecha cotización límite */}
        {/* <div className="inline-flex mt-6 justify-end mb-4 ">
          <div>
            <label
              htmlFor={"fechaCotizacionLimite"}
              class="block mb-2 text-xs font-medium text-gray-900"
            >
              Fecha cotización límite
            </label>
            <Datepicker
              popoverDirection={"down"}
              toggleClassName="absolute text-xs bg-blue-300 rounded-r-lg text-white right-0 h-full px-3 text-gray-400 focus:outline-none disabled:opacity-40 disabled:cursor-not-allowed"
              inputClassName={"rounded-md text-xs bg-gray-50 border border-gray-300 py-2 px-10 text-gray-700"}
              inputId="fechaCotizacionLimite"
              containerClassName={"relative"}
              useRange={false}
              asSingle={true}
              classNames={" z-[9999]"}
              placeholder={"Fecha límite"}
              value={formValues.fechaCotizacionLimite}
              onChange={(e) => {
                if (new Date(e.startDate) > new Date()) {
                  setFormValues((prev) => ({
                    ...prev,
                    fechaCotizacionLimite: e,
                  }));
                  console.log(e);
                } else {
                  toast.warning("La fecha limite es menor a la fecha de hoy", {
                    style: { zIndex: 9999 },
                    position: "top-center",
                  });
                }
              }}
            />
          </div>
        </div> */}

        <div style={{ height: "1px" }} className=" bg-gray-200  w-full"></div>

        {/* Selector de cliente o lead */}
        <div className="mt-6 w-full mb-4">
          <h3 className="text-gray-800 text-base pb-4 text-xs font-semibold">
            ¿El usuario ya es un cliente o aún es un lead/prospecto?
          </h3>
          <ToggleButtonGroup
            color="primary"
            value={formValues.clienteFrecuente}
            exclusive
            onChange={handleChange}
            aria-label="Platform"
            sx={{ 
              borderRadius: "8px",
              width: "100%" 
            }} // Ancho completo
          >
            <ToggleButton
              value={false}
              sx={{ 
                  fontSize: "12px",
                  fontWeight: "bold", 
                  whiteSpace: "nowrap",
                  padding: "4px 24px",
                  flex: 1,
                  fontFamily: "poppins",
                  textTransform: "none",
                }}
            >
              Lead
            </ToggleButton>
            <ToggleButton
              value={true}
              sx={{ 
                fontSize: "12px",
                fontWeight: "bold", 
                whiteSpace: "nowrap",
                padding: "4px 24px",
                flex: 1,
                fontFamily: "poppins",
                textTransform: "none",
              }}
            >
              Cliente
            </ToggleButton>
          </ToggleButtonGroup>
        </div>
        
        {/* Leads */}
        {!formValues.clienteFrecuente && (
          <div className="p-2">
            <div>
              <div className="mx-auto w-full">
                <h3 className="text-gray-800 text-xs pb-4 font-bold">
                  Seleccionar un lead
                </h3>

                <div className=" pb-4 mx-auto">
                  <label
                    htmlFor="default-search"
                    className="mb-2 text-sm font-medium sr-only text-gray-700"
                  >
                    Search
                  </label>
                  <div className="relative w-full ">
                    <div className="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
                      <FaSearch className=" text-gray-600" />
                    </div>
                    <input
                      type="search"
                      id="default-search"
                      value={searchInputLeads}
                      onChange={(e) => setSearchInputLeads(e.target.value)}
                      className="block w-full p-4 ps-10 text-xs  border 0 rounded-lg bg-gray-100 border-gray-300 placeholder-gray-700 text-black "
                      placeholder="Introduce el ID del lead"
                    />
                    <button
                      type="button"
                      onClick={getSubmitLeads}
                      className="text-white absolute end-2.5 bottom-2.5 text-xs focus:ring-4 focus:outline-none font-medium rounded-lg px-4 py-2 bg-blue-600 hover:bg-blue-700 focus:ring-blue-800"
                    >
                      Buscar
                    </button>
                  </div>
                </div>
              </div>

              <div className=" w-full   grid grid-cols-1 gap-2 md:grid-cols-2">
                {allLeadsUserList.map((e) => (
                  <button
                    onClick={() => {
                        const warnings = []

                        if (!e.dni) {
                          warnings.push("DNI")
                        }
                        if (!e.ruc) {
                          warnings.push("RUC")    
                        }
                        if (!e.leadOrigin || e.leadOrigin === "Sin definir") {
                          warnings.push("Origen de lead")
                        }

                        if (warnings.length > 0) {
                          toast.warning(`El lead no cuenta con los siguientes campos: ${warnings.join(", ")}. Actualízalos en la tabla leads!`)
                        } else {
                          setSelectedLead(e)
                        }
                      }
                    }
                    type="button"
                    className={` ${
                      selectedLead?.id === e.id
                        ? "bg-blue-500 text-white"
                        : "bg-gray-50 shadow-sm text-gray-700 hover:bg-blue-50"
                    } p-2 flex flex-col justify-start   rounded-md  `}
                    key={e.id}
                  >
                    <span className=" text-xs font-semibold ">
                      {" "}
                      {e.leadName}
                    </span>
                    <span className=" text-xs font-light "> {e.phone}</span>
                  </button>
                ))}
              </div>
            </div>

            {/* <div className=" h-[1px] bg-gray-300 w-full mt-4"></div> */}
          </div>
        )}

        {/* Clientes */}
        {formValues.clienteFrecuente && (
          <div className="p-2">
            <div>
              <div className="mx-auto w-full">
                <h3 className="text-gray-800 text-xs pb-4 font-bold">
                  Seleccionar un cliente
                </h3>

                <div className=" pb-4 mx-auto">
                  <label
                    htmlFor="default-search"
                    className="mb-2 text-sm font-medium sr-only text-gray-700"
                  >
                    Search
                  </label>
                  <div className="relative w-full ">
                    <div className="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
                      <FaSearch className=" text-gray-600" />
                    </div>
                    <input
                      type="search"
                      id="default-search"
                      value={searchInputClientes}
                      onChange={(e) => setSearchInputClientes(e.target.value)}
                      className="block w-full p-4 ps-10 text-xs  border 0 rounded-lg bg-gray-100 border-gray-300 placeholder-gray-700 text-black "
                      placeholder="Buscar clientes "
                    />
                    <button
                      type="button"
                      onClick={getSubmitClientes}
                      className="text-white absolute end-2.5 bottom-2.5 text-xs focus:ring-4 focus:outline-none font-medium rounded-lg px-4 py-2 bg-blue-600 hover:bg-blue-700 focus:ring-blue-800"
                    >
                      Buscar
                    </button>
                  </div>
                </div>
              </div>

              <div className=" w-full   grid grid-cols-1 gap-2 md:grid-cols-2">
                {allClientesUserList.map((e) => (
                  <button
                    onClick={() => setSelectedCliente(e)}
                    type="button"
                    className={` ${
                      selectedCliente?.id === e.id
                        ? "bg-blue-500 text-white"
                        : "bg-gray-50 shadow-sm text-gray-700 hover:bg-blue-50"
                    } p-2 flex flex-col justify-start   rounded-md  `}
                    key={e.id}
                  >
                    <span className=" text-xs font-semibold ">
                      {" "}
                      {e.nombreComercial}
                    </span>
                    <span className=" text-xs font-light "> {e.email}</span>
                  </button>
                ))}
              </div>
            </div>

            {/* <div className=" h-[1px] bg-gray-300 w-full mt-4"></div> */}
          </div>
        )}

        {/* Fuente lead */}
        {/* <div className="flex flex-col md:grid md:grid-cols-2">
          <SelectInput
            title={"Moneda"}
            value={formValues.moneda}
            options={[
              { value: "PEN", label: "PEN", id: 1 },
              { value: "USD", label: "USD", id: 2 },
            ]}
            placeholder={"Moneda"}
            setValue={(e) => setFormValues((prev) => ({ ...prev, moneda: e }))}
          />
        </div> */}
        
        {/* Registrar cotización */}
        <div className=" my-6 flex justify-center ">
          <button
            type="submit"
            class="text-white bg-[#FF6400] text-xs max-w-sm w-full flex gap-2 justify-center items-center hover:bg-orange-600 transition  duration-500  focus:ring-4 focus:outline-none focus:ring-orange-300 font-medium rounded-lg text-sm px-2.5 py-2.5 text-center "
          >
            Registrar
            <FaCheckCircle className=" " />
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default NuevaCotizacionDialog;
